import SVGIcon, { type SVGIconProps } from "@ch/components/Icons/SVGIcon";
import type { FC } from "react";

type InfoCircleProps = Partial<SVGIconProps>;

/** Hollow info-circle — matches mobile fontello `info-circle` glyph. */
const InfoCircle: FC<InfoCircleProps> = (props) => {
  return (
    <SVGIcon viewBox="0 0 1000 1000" {...props}>
      <path
        d="M500 947.9C252.9 947.9 52.1 747.1 52.1 500 52.1 252.9 252.9 52.1 500 52.1 747.1 52.1 947.9 252.9 947.9 500 947.9 747.1 747.1 947.9 500 947.9ZM500 114.6C287.5 114.6 114.6 287.5 114.6 500 114.6 712.5 287.5 885.4 500 885.4 712.5 885.4 885.4 712.5 885.4 500 885.4 287.5 712.5 114.6 500 114.6ZM500 572.9C482.9 572.9 468.8 558.8 468.8 541.7V333.3C468.8 316.3 482.9 302.1 500 302.1 517.1 302.1 531.3 316.3 531.3 333.3V541.7C531.3 558.8 517.1 572.9 500 572.9ZM500 708.3C494.6 708.3 489.2 707.1 484.2 705 479.2 702.9 474.6 700 470.4 696.3 466.7 692.1 463.8 687.9 461.7 682.5 459.6 677.5 458.3 672.1 458.3 666.7 458.3 661.2 459.6 655.8 461.7 650.8 463.8 645.8 466.7 641.3 470.4 637.1 474.6 633.3 479.2 630.4 484.2 628.3 494.2 624.2 505.8 624.2 515.8 628.3 520.8 630.4 525.4 633.3 529.6 637.1 533.3 641.3 536.2 645.8 538.3 650.8 540.4 655.8 541.7 661.2 541.7 666.7 541.7 672.1 540.4 677.5 538.3 682.5 536.2 687.9 533.3 692.1 529.6 696.3 525.4 700 520.8 702.9 515.8 705 510.8 707.1 505.4 708.3 500 708.3Z"
        fill="currentColor"
      />
    </SVGIcon>
  );
};

export default InfoCircle;
